export const Gross = 'Gross';
export const Net = 'Net';